
export const UPDATE_NAME = 'UPDATE_NAME';
export const UPDATED_MOBILE_NUMBER = 'UPDATED_MOBILE_NUMBER';
export const UPDATE_PROFILE_PASSWORD = 'UPDATE_PROFILE_PASSWORD';